import { render } from "./InitialChatSuggestions.vue?vue&type=template&id=7977d702&scoped=true&ts=true"
import script from "./InitialChatSuggestions.vue?vue&type=script&lang=ts"
export * from "./InitialChatSuggestions.vue?vue&type=script&lang=ts"

import "./InitialChatSuggestions.vue?vue&type=style&index=0&id=7977d702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7977d702"]])

export default __exports__